<div class="editor">
  <!-- The contenteditable div for editing the body content -->
  <div 
    class="editor-content"
    contenteditable="true"
    [innerHTML]="bodyHtml"
    (blur)="onEditorChange($event)">
  </div>

  <!-- CodeMirror editor for viewing or editing raw HTML -->
  <div class="editor-container" *ngIf="editHtml">
    <ngx-codemirror
      [options]="{
        lineNumbers: true,
        mode: 'xml',
        theme: 'default',
        tabSize: 2,
        smartIndent: true,
        lineWrapping: true,
        readonly: false,
        htmlMode: true
      }" 
      (ngModelChange)="changeEditor()"
      [(ngModel)]="html">
    </ngx-codemirror>
  </div>
</div>
